import { render } from "./CreditRequestBasic.vue?vue&type=template&id=6f3213c7"
import script from "./CreditRequestBasic.vue?vue&type=script&lang=js"
export * from "./CreditRequestBasic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__